import { Edit3, Plus, Power, Sparkles } from 'lucide-react';
import { RestaurantDiningRoomDTO } from '../../../../types/restaurant/RestaurantDiningRoomTypes';
import ActionButton from '../../../../components/Buttons/ActionButton';
import IconButton from '../../../../components/Buttons/IconButton';

interface DiningRoomCardProps {
  room: RestaurantDiningRoomDTO;
  onEdit: (room: RestaurantDiningRoomDTO) => void;
  onDeactivate: (room: RestaurantDiningRoomDTO) => void;
  onAddTable: (room: RestaurantDiningRoomDTO) => void;
}

const DiningRoomCard = ({
  room,
  onEdit,
  onDeactivate,
  onAddTable,
}: DiningRoomCardProps) => {
  const updatedAt = new Intl.DateTimeFormat('es-SV', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(room.updatedAt));

  return (
    <article
      className={`group rounded-xl border border-stroke bg-white p-5 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-card dark:border-strokedark dark:bg-boxdark dark:hover:border-primary/40 ${
        room.active ? '' : 'opacity-65'
      }`}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-primary/15 bg-primary/10 text-primary transition group-hover:bg-primary group-hover:text-white">
            <Sparkles className="h-5 w-5" />
          </span>

          <div className="min-w-0">
            <h3 className="truncate text-base font-semibold text-black dark:text-white">
              {room.name}
            </h3>

            <p className="mt-1 text-sm text-bodydark2 dark:text-bodydark">
              Orden #{room.displayOrder}
            </p>
          </div>
        </div>

        <span
          className={`shrink-0 rounded-full border px-2.5 py-1 text-xs font-medium ${
            room.active
              ? 'border-success/20 bg-success/10 text-success'
              : 'border-danger/20 bg-danger/10 text-danger'
          }`}
        >
          {room.active ? 'Activo' : 'Inactivo'}
        </span>
      </div>

      <p className="mt-5 min-h-[48px] text-sm leading-6 text-bodydark2 dark:text-bodydark">
        {room.description || 'Sin descripción adicional.'}
      </p>

      <p className="mt-3 text-xs text-bodydark2">Actualizado: {updatedAt}</p>

      <div className="mt-5 flex gap-2 border-t border-stroke pt-4 dark:border-strokedark">
        <ActionButton
          label="Editar"
          icon={<Edit3 size={16} />}
          variant="secondary"
          size="md"
          fullWidth
          onClick={() => onEdit(room)}
        />

        {room.active && (
          <ActionButton
            label="Mesa"
            icon={<Plus size={16} />}
            variant="outline"
            size="md"
            fullWidth
            onClick={() => onAddTable(room)}
          />
        )}

        {room.active && (
          <IconButton
            icon={<Power size={16} />}
            variant="danger"
            size="md"
            title="Desactivar salón"
            onClick={() => onDeactivate(room)}
          />
        )}
      </div>
    </article>
  );
};

export default DiningRoomCard;
